var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V4.03081C13.5712 4.09856 14.3612 4.27657 15.1051 4.55001L15.5 3.86603C15.7761 3.38773 16.3877 3.22386 16.866 3.5L17.732 4C18.2103 4.27614 18.3742 4.88773 18.0981 5.36603L17.7081 6.04142C19.718 7.69201 21 10.1963 21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 10.1963 4.28204 7.69201 6.29186 6.04142L5.90192 5.36603C5.62578 4.88773 5.78966 4.27614 6.26795 4L7.13397 3.5C7.61227 3.22386 8.22386 3.38773 8.5 3.86603L8.8949 4.55001C9.63877 4.27657 10.4288 4.09856 11.25 4.03081V2C11.25 1.58579 11.5858 1.25 12 1.25ZM11.1286 11.1993C10.4606 11.5232 10 12.2078 10 13C10 14.1046 10.8954 15 12 15C13.1046 15 14 14.1046 14 13C14 12.2078 13.5394 11.5232 12.8714 11.1993L12.5356 6.49873C12.5156 6.21772 12.2817 6 12 6C11.7183 6 11.4844 6.21772 11.4644 6.49873L11.1286 11.1993Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.346ea20a640affa82e1b44d0a36daabd.svg";
export { ForwardRef as ReactComponent };